<!--<h1 class="mb30">{{'PASSWORD_SET_SUCCESS.MSG' | translate}}</h1>-->
<span class="custom-login-info" style="padding-bottom: 10px; display: block">Passwort geändert</span>

<p style="margin: 15px 0 25px 0; font-size: 16px; color: #505456;">
    Ihr Passwort wurde erfolgreich zurückgesetzt.
</p>

<app-button (clickEvent)="globusCustomLoginRedirect()" [btnOption]="buttonOptions.backToLogin" class="login-btn">
</app-button>
